export const initialAgentLogsState = {
    messageLogsByProjectId: {},
};
